module.exports = __webpack_public_path__ + "img/analytics-device@2x.0a907d00.jpg";